<template>
  <v-card class="pr-lg-12 pl-lg-12">
    <template v-for="msg in messages">
      <v-card-title :key="msg.id" class="pb-0">
        <v-alert outlined dense type="error" icon="info" class="fixwordwrap">
          <b><span v-html="msg.header" /></b><br>                     
          <span v-html=" msg.content" />
        </v-alert>
      </v-card-title>     
    </template>
    <!-- <v-card-title class="pb-0">
      <v-alert outlined dense type="error" icon="info">
        <b>INGEN TIDNING PÅ NATIONALDAGEN DEN 6 JUNI - TIDNINGEN SOM LEVERERAS DEN 5 JUNI SKALL SÄLJAS I TVÅ DAGAR</b><br>                     
        Aftonbladet och Expressen/GT/KvP som ges ut den 5 juni skall säljas i två dagar. 
        Det levereras ingen tidning den 6 juni. (Vi kommer precis som övriga dagstidningar att ha en tidningsfri dag). 
        <br/>Returen för tidningen daterad den 5 juni kommer att börja efterfrågas den 6 juni kl 12 eftersom tidningarna alltså skall säljas även den här dagen.
        För mer info – <a href="https://kvallstidningarna.se/app/uploads/2023/05/5-6-juni-information-a4-scaled.jpg" target="_blank">klicka här</a>
      </v-alert>
    </v-card-title> -->
    <v-card-title primary-title>
      <div v-if="reportState == 2" class="text-h4">        
        Ändra/tillägg
      </div>
      <div v-else class="text-h4">        
        Returrapportera        
      </div>                  
      
      <v-spacer />         
      <v-btn :loading="isGenerating"                 
             small
             @click="generatePdf()"
      > 
        <v-icon>
          print
        </v-icon>
        Skriv ut
      </v-btn>
    </v-card-title>   
    
    <v-row
      wrap
      color="error"
    > 
      <v-btn v-if="$vuetify.breakpoint.smAndDown"
             ref="saveBtn" 
             label="Fortsätt"
             hide-details="auto"                                             
             dark
             fixed
             tile
             bottom
             right
             color="success"            
             class="kvt-btn v-btn top"
             style="height:3em;"
             :disabled="!valid"
             @click="save()"              
      > 
        Spara &#38;<br> Fortsätt
      </v-btn>           
      <ReturnList     
        ref="newspaper"      
        :key="listPaperTypes[0]"
        :paper-type="listPaperTypes[0]"
        :label="paperTypes[listPaperTypes[0]]"
        :report-state="reportState"               
      />

      <ReturnList            
        ref="insert"               
        :key="listPaperTypes[1]"
        :paper-type="listPaperTypes[1]"
        :label="paperTypes[listPaperTypes[1]]"
        :report-state="reportState"          
      />
    </v-row>
    <v-row dense cols="12"                 
           :justify="$vuetify.breakpoint.smAndDown?'center':'end'"   
           class="pb-2 pr-2"              
    >           
      <v-col cols="2">
        <v-btn ref="saveBtn" 
               label="Spara &#38; Fortsätt"
               hide-details="auto"                 
               dense
               block
               color="success"  
               :disabled="!valid || saving"
               @click="save()"              
        > 
          Spara &#38; Fortsätt
        </v-btn>
      </v-col>
    </v-row>           
    <ConfirmReportDialog ref="confirmDialog" :opened-from-return="true" @saved="close" />    
    <vue-html2pdf ref="html2Pdf" 
                  filename="Returer"
                  :show-layout="false"
                  :preview-modal="false"
                  :manual-pagination="true"          
                  :float-layout="true"
                  pdf-format="a4"
                  pdf-content-width="100%"                  
                  @progress="onProgress($event)"
                  @hasDownloaded="hasDownloaded($event)"
    >
      <section slot="pdf-content">
        <section v-for="(type, idx) in listPaperTypes"
                 :key="type"
                 class="pdf-item"
                 style="margin:80px;"
        >
          <ReturnList                       
            :key="type"
            :paper-type="type"
            :label="paperTypes[type]"
            :report-state="reportState"     
            :printing="true"     
          />      
          <div v-if="idx===0" class="html2pdf__page-break" />
        </section>    
      </section>
    </vue-html2pdf>        
  </v-card>
</template>

<script>
import * as pt from '@/model/paperTypes'
import ReturnList from '@/components/web/ReturnList'

import { mapState, mapMutations } from 'vuex'
import {APP_PAPERS, APP_OPEN_BUNDLES} from '@/store/appStates'
import { SET_PAPERS, SET_OPEN_BUNDLES, REMOVE_LAST_SELECTED_BUNDLE_ID, SET_LAST_SELECTED_BUNDLE_ID } from '@/store/appMutations'
import log from '@/logger'
import api from '@/backend/api'
import VueHtml2pdf from 'vue-html2pdf'

import ConfirmReportDialog from '@/components/web/dialogs/ConfirmReportDialog'

export default {
  name: 'Returns',
  components: { ReturnList, ConfirmReportDialog, VueHtml2pdf},
  data() {
    return {
      paperTypes: pt.types,
      listPaperTypes: [ pt.NEWSPAPER, pt.INSERT ],
      reportState: this.$route.params.reportState,
      valid: true,
      errors:[],
      showConfirm:false,
      saving:false,
      progress:0,
      isGenerating:false,
      htmltopdfoptions: {
        margin: 1
      },
      messages:[]
    }
  },
  
  computed: {
    ...mapState({  
      allPapers: state => state[APP_PAPERS],
      theBundles: state => state[APP_OPEN_BUNDLES],
        
    }),
    papers(){
      return this.allPapers[pt.NEWSPAPER].concat(this.allPapers[pt.INSERT])
    },
    openBundles() {
      return this.theBundles[pt.NEWSPAPER].concat(this.theBundles[pt.INSERT])

    },
  },
  watch: {
    '$route' (to, from) {
      console.log('Route', to, from)
      this.reportState = to.params.reportState
    }
  },
  mounted() {
    this.loadMessges()
  },
  created(){
    this.getReportState()
  },
  methods:{
     ...mapMutations({
      setPapers: SET_PAPERS,
      setOpenBundles: SET_OPEN_BUNDLES,
      resetState: REMOVE_LAST_SELECTED_BUNDLE_ID,
      setLastBundleId: SET_LAST_SELECTED_BUNDLE_ID
    }),
    getReportState(){
      this.reportState = Number(this.$route.params.reportState)
    },
    reported(paper){
      if(this.reportState == 1){
        const index = this.papers.findIndex(p => p.id === paper.id)
        console.log(`${paper.id} found at ${index}`)
        if(index >= 0){
          this.papers.splice(index,1)
        }
      }
    },
    hasError(data){
      const index = this.papers.findIndex(p => p.id === data.id)
      console.log(`${data.id} found at ${index}`)
      if(index >= 0){
        const paper = this.papers[index]
         this.$set(paper, 'hasError', true)
         this.$set(paper, 'error', data.error)        
      }
    },
    validate() {
      return ( (this.$refs.newspaper !== undefined && this.$refs.newspaper.validate()) && 
               (this.$refs.insert !== undefined &&this.$refs.insert.validate()) )
    },    
    save() {
      if(this.validate() && !this.saving){      
        this.saving=true
        var promises = []
        this.papers.forEach(paper => {              
          paper.returns.forEach(ret => {
            let bundleId = ret.bundleId
            let amount = ret.amount
            if(paper.hasError !== undefined){
              this.$set(paper, 'hasError', false)
              this.$set(paper, 'error', undefined)            
            }
                                  
            if (ret.isOpen && bundleId && amount >= 0) {
                promises.push(api.addPapers(bundleId, paper, amount))  
                //promises.push(api.addPapersTemporary(bundleId, paper, amount))
            }          
          })                       
        })
        
        Promise.all(promises.map(
            p => p.catch(errors => { 
              log.debug('SaveReturn Errors...', errors.response.data.error)
              this.hasError(errors.response.data)                
                window.scrollTo(0, 0)
            })
          )).then(results => {
            results.forEach(resp => {
              if(resp !== undefined){
                log.debug('SaveReturn Success...', resp.data.paper)
                this.reported(resp.data.paper)
              }
            })                  
            if(!results.includes(undefined)){
              if(results.length >0) {
                var types = results.map(item => item.data.paper.type).filter((value, index, self) => self.indexOf(value) === index)
                
                types.forEach(r=>{
                  var paperType = r
                  api.getOpenBundles(paperType).then(resp => {
                    log.debug(`Bundles[${paperType}]:`, resp.data)                  
                    resp.data.forEach(b=>{
                      this.$set(b,'open',undefined)
                    }) 
                    this.setOpenBundles({ bundles: resp.data, paperType })
                    
                  })              
                })                             
                this.$refs['confirmDialog'].open()
              }
            }
          })
          .catch(errors => {
            log.debug('SaveReturn Catch...', errors)            
          })
          // })
          // .then(results => {
          //   results.forEach(resp => {
          //     log.debug('SaveReturn Success...', resp)
          //     this.reported(resp.data)
          //   })
          // })
          // .catch(errors => {
          //   log.debug('SaveReturn Errors...', errors.response.data.error)
          //   error = true
          // })
          .finally(() => {  
            this.saving= false        
          })
      }     
      
    },    
    openBuntar(){
       this.$refs['confirmDialog'].open()
    },
    close(){       
       this.$refs.newspaper.loadData(this.reportState)
       this.$refs.insert.loadData(this.reportState)
    },
    generatePdf(){  
      this.isGenerating = true
       this.$refs.html2Pdf.generatePdf()
    },
    onProgress(progress) {
      this.progress = progress
      log.debug(`PDF generation progress: ${progress}%`)
    },
    hasDownloaded(){
        this.isGenerating = false
    },
    loadMessges(){
      console.log('Get messages')
      var self = this
      api
        .getCustomersMessages(4)
        .then((resp) => {
          log.debug(resp.data)          
          this.messages = resp.data
        })       
        .catch((err) => {
          if (
            (err.response && err.response.status === 401) ||
            err.response.status === 403
          ) {
            console.log(err)
            self.loading = false
            self.$router.push({ name: 'root' })
          } else if (err.response && err.response.status === 404) {
            console.log(err)
            self.loading = false
          }
        })
    }
  },  
}
</script>

<style lang="scss">  
  .kvt-btn {
    top:10em;      
  }
    .top{
      z-index:4;      
    }
  .fixwordwrap p{
    word-break: break-word;
    white-space: normal;
  }
</style>